module.exports = __webpack_public_path__ + "img/illustration-ventilation.aee5ea16.svg";